/**
 * @file コンポーネント：フル動画ページタイムラインアイテム DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { TimelineItemComment } from "~/src/components/projects/Video/TimelineItemComment";
import { TimelineItemDevice } from "~/src/components/projects/Video/TimelineItemDevice";
import { TimelineItemEvent } from "~/src/components/projects/Video/TimelineItemEvent";
import { TimelineItemSchema } from "~/src/components/projects/Video/TImelineItemSchema";

// スタイル設定読み込み
import {
    StyledItem,
    StyledItemButton,
    StyledItemEditContainer,
    StyledItemEditlist,
    StyledItemEditlistItem,
    StyledItemEditlistItemLink,
    StyledItemEditlistItemLinkIcon,
    StyledItemEditlistItemLinkText,
    StyledItemEditText,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledItem ref={props.refTimelineItem}>
            <StyledItemButton
                className={
                    props.isEditPage !== true &&
                    props.isPaid === true &&
                    props.isPurchased === false &&
                    "is-dummy-disabled"
                }
                onClick={() =>
                    props.fnOnClickButton(props.itemTime, props.itemText)
                }
                ref={props.refTimelineItemButton}
                title={
                    props.isEditPage !== true &&
                    props.isPaid === true &&
                    props.isPurchased === false
                        ? localized["Label.PurchaseToPlayFullvideo"]
                        : null
                }
            >
                {/* コメント */}
                {props.type === "comment" && (
                    <TimelineItemComment
                        refText={props.refTimelineItemText}
                        text={props.itemText}
                        time={props.itemTime}
                        thumbnail={props.thumbnail}
                    />
                )}
                {/* イベント */}
                {props.type === "event" && (
                    <TimelineItemEvent
                        refText={props.refTimelineItemText}
                        text={props.itemText}
                        time={props.itemTime}
                    />
                )}
                {props.listDevice && props.listDevice.length > 0 && (
                    // 機器リストがある場合のみ
                    <TimelineItemDevice listDevice={props.listDevice} />
                )}
                {props.listSchema && props.listSchema.length > 0 && (
                    // シェーマリストがある場合のみ
                    <TimelineItemSchema
                        listSchema={props.listSchema}
                        setClickedSlideIndex={props.setClickedSlideIndex}
                        setIsOpenPopupSchema={props.setIsOpenPopupSchema}
                        setPopupSchemaSlider={props.setPopupSchemaSlider}
                        setIsMouseOverPopupSchemaButton={
                            props.setIsMouseOverPopupSchemaButton
                        }
                    />
                )}
            </StyledItemButton>
            {props.isEditPage === true && (
                // 執刀医権限フル動画ページの場合のみ
                <StyledItemEditContainer
                    data-edit-language={props.languageCodeOperation}
                >
                    {props.languageCodeOperation === "en" && (
                        <StyledItemEditText>
                            {localized["Label.UneditableEnglishData"]}
                        </StyledItemEditText>
                    )}
                    <StyledItemEditlist>
                        <StyledItemEditlistItem>
                            <StyledItemEditlistItemLink
                                className={
                                    props.languageCodeOperation === "en" &&
                                    "is-disabled"
                                }
                                href="#"
                                onClick={(e) =>
                                    props.fnSetModalEdit(
                                        e,
                                        props.type,
                                        "edit",
                                        {
                                            context:
                                                props.refTimelineItemText
                                                    .current.innerText,
                                            id: props.itemId,
                                            time: props.itemTime,
                                        }
                                    )
                                }
                            >
                                <StyledItemEditlistItemLinkIcon>
                                    <i className="fas fa-edit"></i>
                                </StyledItemEditlistItemLinkIcon>
                                <StyledItemEditlistItemLinkText>
                                    {localized["Label.Edit"]}
                                </StyledItemEditlistItemLinkText>
                            </StyledItemEditlistItemLink>
                        </StyledItemEditlistItem>
                        <StyledItemEditlistItem>
                            <StyledItemEditlistItemLink
                                className={
                                    props.languageCodeOperation === "en" &&
                                    "is-disabled"
                                }
                                href="#"
                                onClick={(e) =>
                                    props.fnSetModalEdit(
                                        e,
                                        props.type,
                                        "delete",
                                        {
                                            context:
                                                props.refTimelineItemText
                                                    .current.innerText,
                                            id: props.itemId,
                                            time: props.itemTime,
                                        }
                                    )
                                }
                            >
                                <StyledItemEditlistItemLinkIcon>
                                    <i className="fas fa-trash"></i>
                                </StyledItemEditlistItemLinkIcon>
                                <StyledItemEditlistItemLinkText>
                                    {localized["Label.Delete"]}
                                </StyledItemEditlistItemLinkText>
                            </StyledItemEditlistItemLink>
                        </StyledItemEditlistItem>
                    </StyledItemEditlist>
                </StyledItemEditContainer>
            )}
        </StyledItem>
    );
};
